// extracted by mini-css-extract-plugin
export default {"container":"Messages_container__ZAyOX","signin":"Messages_signin__tYcjV"};